import CustomerDeliveryFileRegister from '@components/file-register/customer-delivery-files';

const CustomerDeliveryFileRegisterPage = () => {
  return <CustomerDeliveryFileRegister />;
};

export default CustomerDeliveryFileRegisterPage;
